import { render, staticRenderFns } from "./abnormalDetail.vue?vue&type=template&id=c6897d3c&scoped=true&"
import script from "./abnormalDetail.vue?vue&type=script&lang=js&"
export * from "./abnormalDetail.vue?vue&type=script&lang=js&"
import style0 from "./abnormalDetail.vue?vue&type=style&index=0&id=c6897d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6897d3c",
  null
  
)

export default component.exports